import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import getQuery from '../../helpers/api/get-query'
import Ribbon from '../../types/api/ribbon'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'

export const ribbonsApi = createApi({
    reducerPath: 'ribbonsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Ribbons', 'Orders'],
    endpoints: builder => ({
        getMyRibbons: builder.query<Strapi<Ribbon>, EndpointQueryParameters | void>({
            query: getQuery('/ribbons/my'),
            providesTags: ['Ribbons'],
        }),
        createRibbon: builder.mutation<StrapiSingle<Ribbon>, StrapiCreate<Ribbon>>({
            query: body => ({
                url: '/ribbons',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Ribbons', 'Orders'],
        }),
        updateAndCalculateRibbon: builder.mutation<StrapiSingle<Ribbon>, StrapiUpdate<Ribbon>>({
            query: ({ docId, body }) => ({
                url: `/ribbons/${docId}/update-and-calculate`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Ribbons', 'Orders'],
        }),
    }),
})

export const {
    useGetMyRibbonsQuery,
    useCreateRibbonMutation,
    useUpdateAndCalculateRibbonMutation,
} = ribbonsApi
